import { Suspense } from 'react';
import { Countdown } from '@pixum/countdown';
import type { CountdownNode } from 'data-layer';

interface CountdownWrapperProps {
  countdown: CountdownNode;
}

export function CountdownWrapper({ countdown }: CountdownWrapperProps) {
  return (
    <Suspense fallback={<div className="countdown" />}>
      <Countdown deadline={countdown.deadline} segmentLabels={countdown.segmentLabels} timezone={countdown.timezone} />
    </Suspense>
  );
}
